export const isEtude = (documentId: string) => documentId.includes("_E")